export default {
  default: () => import("C:/wamp64/www/dev/denet_parallel/pagina_WEB_Primavera/nuxt/layouts/default.vue").then(m => m.default || m)
}